// libraries
import React from 'react'

// components
import Section from '/react4xp/components/Section'
import Button from '/react4xp/components/Button'
import AllIdeas from '/react4xp/components/Idea/AllIdeas/index_prototype'
import { IdeaCardProps } from '/react4xp/components/Idea/IdeaCard'

interface UserIdeasProps {
	strings: {
		ideasHeader: string
		ideasIntro: string
		ideasMainButton: string
        ideasMainButtonUrl: string
	}
    ideas: IdeaCardProps[]
    howManyIdeas?: number
    loadMoreText: string
}

export default function UserIdeas({
    strings,
    ideas,
    howManyIdeas,
    loadMoreText
}: UserIdeasProps) {

	return (
        (ideas.length > 0) ? (
            <AllIdeas
                section={{
                    bgColor: 'red',
                    paddingTop: 'none',
                    className: 'user-ideas'
                }}
                title={strings.ideasHeader}
                items={ideas}
                howManyItemsToShow={howManyIdeas}
                loadMore={{
                    text: loadMoreText,
                    isWhite: true
                }}
            />
        ) : (
            <Section
                bgColor='red'
                paddingTop='none'
                className='user-ideas--no-results'
            >
                <div className='container'>
                    <div className='row'>
                        <div className='col-md-10 offset-md-1 col-lg-8 offset-lg-2 col-xl-6 offset-xl-3'>
                            <div className='content bg-white'>

                                <h2 className='title h3'>
                                    {strings.ideasHeader}
                                </h2>

                                <div
                                    className='desc negative-margin'
                                    dangerouslySetInnerHTML={{
                                        __html: strings.ideasIntro
                                    }}
                                />

                                <Button
                                    href={strings.ideasMainButtonUrl}
                                    color='transparent'
                                    hover='blue'
                                    hasBorders
                                    noUnderline
                                >
                                    {strings.ideasMainButton}
                                </Button>

                            </div>
                        </div>
                    </div>
                </div>
            </Section>
        )
    )
}